import { BydValidationInterface } from '../interfaces/byd-validation.interface';

export class BydValidation {
  /**
   * Description.
   */
  public label: string;

  /**
   * Color.
   */
  public color: string;

  /**
   * IsExpired.
   */
  public isExpired?: boolean;

  /**
   * Tooltip.
   */
  public tooltip?: string;

  /**
   * @param data Data.
   */
  constructor(data: BydValidationInterface) {
    if (data) {
      this.label = data.label;
      this.color = data.color;
      this.isExpired = data.isExpired;
      if (data.tooltip) this.tooltip = data.tooltip;
    }
  }
}
